import { loadCallsSearchTable } from '../rest-services/search-rest-service';
import { transformCallsSearchData } from '../filters/search-filters';

export const getCallsSearchTable = async (params, transformFunc) => {
  const table = await loadCallsSearchTable(params);
  return transformCallsSearchData(table.data, transformFunc);
};
